module.exports = __webpack_public_path__ + "img/icon_file.4ef2029a.svg";